var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloseLight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.76221 8.49948L15.7444 2.51704C15.9089 2.35236 15.9997 2.13265 16 1.89837C16 1.66397 15.9092 1.444 15.7444 1.27958L15.2202 0.75548C15.0553 0.590407 14.8356 0.5 14.6011 0.5C14.367 0.5 14.1473 0.590407 13.9824 0.75548L8.00026 6.73753L2.01782 0.75548C1.85327 0.590407 1.63343 0.5 1.39902 0.5C1.16488 0.5 0.945041 0.590407 0.780488 0.75548L0.256 1.27958C-0.0853333 1.62091 -0.0853333 2.1761 0.256 2.51704L6.23831 8.49948L0.256 14.4817C0.0913171 14.6466 0.000650406 14.8663 0.000650406 15.1006C0.000650406 15.3349 0.0913171 15.5546 0.256 15.7194L0.780358 16.2435C0.944911 16.4084 1.16488 16.499 1.39889 16.499C1.6333 16.499 1.85314 16.4084 2.01769 16.2435L8.00013 10.2613L13.9823 16.2435C14.1471 16.4084 14.3668 16.499 14.601 16.499H14.6012C14.8355 16.499 15.0552 16.4084 15.22 16.2435L15.7443 15.7194C15.9088 15.5547 15.9996 15.3349 15.9996 15.1006C15.9996 14.8663 15.9088 14.6466 15.7443 14.4818L9.76221 8.49948Z",
    fill: "#AEB4C8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseLight);
export default __webpack_public_path__ + "static/media/close-light.0ec7df3b79b34ceaed6b7d30a12f1dd6.svg";
export { ForwardRef as ReactComponent };